import { render } from "./OurJourney.vue?vue&type=template&id=0776758a"
import script from "./OurJourney.vue?vue&type=script&lang=js"
export * from "./OurJourney.vue?vue&type=script&lang=js"

import "./OurJourney.vue?vue&type=style&index=0&id=0776758a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__